export { default as CompanySmartContractSettingsDefaultSplitParts } from './CompanySmartContractSettingsDefaultSplitParts';
